import React from "react";
import classNames from 'classnames';
import "./AccountList.scss";
import { USER_ROLE, CanEdit } from "../signin/RoleContext";
import AccountInfo from "../viewModels/AccountInfo"
import { useHistory } from "react-router-dom";
import ToolTipView from "../toolTipView/ToolTipView";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Auth from "../services/Auth";
interface Props {
  account: AccountInfo;
  userRoles: USER_ROLE[];
  onDelete: (deleteId: number) => void;
}

const AccountListItem = (props: Props) => {
  const history = useHistory();

  const editUser = async () => {
    history.push(`/account/${props.account.agentOrLicenseeNumber}/users/${props.account.id}`);
  }

  return (
    <div className="table-row">
      <div>{props.account.name}</div>
      <div>{props.account.email}</div>
      <div>{props.account.phone}</div>
      <div>
        {
          CanEdit(props.userRoles) && <><ToolTipView placement="top" title="Edit user">
              <button className={classNames({ edit: true, btn: true, 'btn-navy': true })} value="Edit" onClick={editUser}>
                <FontAwesomeIcon icon="edit" />
              </button>
            </ToolTipView>
            <ToolTipView placement="top" title="Delete user">
              <button className={classNames({ edit: true, btn: true, 'btn-navy': true })} value="Delete" onClick={() => props.onDelete(props.account.id)}>
                  <FontAwesomeIcon icon="trash-alt" />
                </button>
              </ToolTipView>
          </>
        }
      </div>
    </div>
  );
};

export default AccountListItem;
